import { useQuery } from "@tanstack/react-query";
import { client } from "./client";

export const useGetToken = () => {
    const token = localStorage.getItem("accessToken");
    return useQuery({
        queryKey: ["token"],
        queryFn: async () => {
            const response = await client("token", {
                method: "GET",
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};
